import { render } from "./SearchBar.vue?vue&type=template&id=7fe39348&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=ts"
export * from "./SearchBar.vue?vue&type=script&lang=ts"

import "./SearchBar.vue?vue&type=style&index=0&id=7fe39348&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7fe39348"

export default script